import React from 'react'

import { Button } from '@/components/ui/button'
import useDialog from '@/hooks/useDialog'
import { useRqCertifiedAssessmentOrFail } from '@/hooks/useRqCertifiedAssessmentQuery'
import ConfirmNdaModal from '@/pages/rqCertifiedApplicationStatus/components/Content/shared/ConfirmNdaModal'
import MakePaymentClaimModal from '@/pages/rqCertifiedApplicationStatus/components/Content/shared/MakePaymentClaimModal'

const StartApplicationButtons: React.FC = () => {
  const assessment = useRqCertifiedAssessmentOrFail()

  const {
    isShowingDialog: isShowingConfirmNdaDialog,
    showDialog: showConfirmNdaDialog,
    hideDialog: hideConfirmNdaDialog,
  } = useDialog()

  const {
    isShowingDialog: isShowingMakePaymentClaimDialog,
    showDialog: showMakePaymentClaimDialog,
    hideDialog: hideMakePaymentClaimDialog,
  } = useDialog()

  const shouldShowConfirmNdaModal = !assessment.ndaAgreedAt

  return (
    <>
      <Button
        variant="primary"
        className="w-full sm:w-auto"
        onClick={() => {
          if (shouldShowConfirmNdaModal) {
            showConfirmNdaDialog()
          } else {
            showMakePaymentClaimDialog()
          }
        }}
      >
        Start your application
      </Button>

      {isShowingConfirmNdaDialog && (
        <ConfirmNdaModal
          onConfirm={() => {
            hideConfirmNdaDialog()
            showMakePaymentClaimDialog()
          }}
          onHide={hideConfirmNdaDialog}
        />
      )}

      {isShowingMakePaymentClaimDialog && (
        <MakePaymentClaimModal onHide={hideMakePaymentClaimDialog} />
      )}
    </>
  )
}

export default StartApplicationButtons
